import { toast } from 'react-toastify';

import type { ApiError } from './types';

/**
 * Toast a failed write's normalized message — unless a global seam already
 * spoke for it.
 *
 * The 403 seam (`setPermissionDeniedHandler`) surfaces every refused write in
 * one place, so a feature that also toasted its own error would say the same
 * sentence twice. Rather than teaching every feature to recognise 403 — the
 * per-feature checking FE-ADR-021 refused for 402 — the client marks the error
 * `handled` and this helper reads that one flag.
 *
 * Use it wherever a mutation's failure was previously toasted raw.
 */
export function toastApiError(error: unknown): void {
  const apiError = error as ApiError | undefined;
  if (apiError?.handled) return;
  toast.error(apiError?.message);
}
